import React from "react";
import Table from "react-bootstrap/Table";

function DruzynowiTableComponent() {
  return (
    <Table>
      <thead>
        <tr>
          <th>2025 - dzisiaj</th>
          <th>Jacek Krzystek Pwd.</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>2023 - 2025</td>
          <td>Mateusz Wasiuk Ćw.</td>
        </tr>
        <tr>
          <td>2018 - 2023</td>
          <td>Jan Andrzejczyk Pwd.</td>
        </tr>
        <tr>
          <td>2016 - 2018</td>
          <td>Bartłomiej Rój Pwd.</td>
        </tr>
        <tr>
          <td>2012 - 2016</td>
          <td>Dawid Rój Pwd.</td>
        </tr>
        <tr>
          <td>2010 - 2012</td>
          <td>Rafał Kochaj Pwd.</td>
        </tr>
        <tr>
          <td>2005 - 2010</td>
          <td>Konrad Kaptur Pwd.</td>
        </tr>
        <tr>
          <td>2003 - 2005</td>
          <td>Grześ Minor Pwd.</td>
        </tr>
        <tr>
          <td>2000 - 2003</td>
          <td>Marek Witko Pwd.</td>
        </tr>
        <tr>
          <td>1999 - 2000</td>
          <td>Adam Kotulecki Ćw.</td>
        </tr>
        <tr>
          <td>1997 - 1999</td>
          <td>Grześ Janiec HO.</td>
        </tr>
        <tr>
          <td>1995 - 1997</td>
          <td>Piotr Kaptur HO.</td>
        </tr>
        <tr>
          <td>1993 - 1995</td>
          <td>Genio Pozniak Ćw.</td>
        </tr>
        <tr>
          <td>1992 - 1993</td>
          <td>Tadek Dan Pwd.</td>
        </tr>
        <tr>
          <td>1991 - 1992</td>
          <td>Gabriel Dan Ćw.</td>
        </tr>
        <tr>
          <td>1987 - 1991</td>
          <td>Tadek Dan Pwd.</td>
        </tr>
        <tr>
          <td>1982 - 1987</td>
          <td>Bogdan Jodła HRp.</td>
        </tr>
        <tr>
          <td>1980 - 1982</td>
          <td>Ludek Kowalewski HO.</td>
        </tr>
        <tr>
          <td>1978 - 1980</td>
          <td>Jurek Maczugowski HO.</td>
        </tr>
        <tr>
          <td>1976 - 1978</td>
          <td>Piotr Kaptur HO.</td>
        </tr>
        <tr>
          <td>1975 - 1976</td>
          <td>Romek Kowalewski HO.</td>
        </tr>
        <tr>
          <td>1974 - 1975</td>
          <td>Marek Kowalewski HO.</td>
        </tr>
        <tr>
          <td>1972 - 1974</td>
          <td>Henio Misiewiez Pwd.</td>
        </tr>
        <tr>
          <td>1971 - 1972</td>
          <td>Sławomir Kucharek HO.</td>
        </tr>
        <tr>
          <td>1970 - 1971</td>
          <td>Jurek Machorowski Ćw.</td>
        </tr>
        <tr>
          <td>1969 - 1970</td>
          <td>Maciek Matuszak Pwd.</td>
        </tr>
        <tr>
          <td>1967 - 1969</td>
          <td>Bogusław Kucharek Pwd.</td>
        </tr>
        <tr>
          <td>1965 - 1967</td>
          <td>Jurek Cembała Pwd.</td>
        </tr>
        <tr>
          <td>1964 - 1965</td>
          <td>Maciek Kołodziejski HO.</td>
        </tr>
        <tr>
          <td>1961-1964</td>
          <td>Marian Scicinski Hm.</td>
        </tr>
        <tr>
          <td>1959-1961</td>
          <td>Jan Dunin-Borkowski HO.</td>
        </tr>
        {/* Add more rows as needed */}
      </tbody>
    </Table>
  );
}

export default DruzynowiTableComponent;
